import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import defaultProductCardFallbackIcon from 'assets/icons/image-coming-soon.svg';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const DefaultFallbackImage = t0 => {
  const $ = _c(3);
  const {
    brokenImageSrc,
    className
  } = t0;
  const t1 = className || "";
  let t2;
  if ($[0] !== brokenImageSrc || $[1] !== t1) {
    t2 = <img src={isNewConsumerApp ? "/static/assets/icons/image-coming-soon.svg" : defaultProductCardFallbackIcon} width="189" height="189" alt="" className={t1} data-broken-image-src={brokenImageSrc} />;
    $[0] = brokenImageSrc;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
DefaultFallbackImage.propTypes = {
  className: PropTypes.string,
  brokenImageSrc: PropTypes.string
};
export default DefaultFallbackImage;